export const DH = {
  Container: `wcn-payment-widget-app`,
  GeneralError: `wcn-general-error-message`,
  StepTitle: 'wcn-step-title',
  PaymentComplete: {
    Container: `wcn-payment-complete`,
    Title: `wcn-payment-complete-title`,
    Description: `wcn-transaction-info`,
  },
  ProceedButton: `cashier-payments-method-pay-button`,
  BackButton: 'wcn-back-button',
  AppLoader: `pa-app-loader`,
  WidgetWrapper: 'pw-wrapper',
  UserInfoForm: {
    Container: 'wcn-user-info-form',
    Line: 'wcn-pay-app_user-info_line',
    CountryDropdown: 'cashier-payments-method-dropdown',
    CountriesLoader: 'wcn-pay-app_countries-loader',
    Field: (fieldName: string) => `wcn-pay-app_user-info_${fieldName}`,
  },
};
